import { styled } from '@mui/material'
import DateLinearProgress from '@src/components/share/generic/DateLinearProgress'
import React from 'react'
import { useTranslation } from 'react-i18next'

const Text = styled('div')`
  font-size: 12px;
  line-height: 14px;
  color: #ffffff;
`

const Title = styled('div')`
  font-size: 16px;
  line-height: 18px;
  color: #c4c4c4;
`

const TextContainer = styled('div')`
  height: 12px;
  display: flex;
  margin: 3px 0;
  justify-content: space-between;
`

export const CoreStateProgress: React.FC<CoreStateProgressProps> = props => {
  const { className, startAt, endAt, now } = props

  const { t } = useTranslation()

  return (
    <div className={className}>
      <Title>{t('planet.date_progress_bar.core_state.title')}</Title>
      <TextContainer>
        <Text>{t('planet.date_progress_bar.core_state.start_value')}</Text>
        <Text>{t('planet.date_progress_bar.core_state.end_value')}</Text>
      </TextContainer>
      <DateLinearProgress startAt={startAt} endAt={endAt} now={now} />
    </div>
  )
}

export type CoreStateProgressProps = {
  className?: string
  startAt: Date
  endAt: Date
  now: Date
}
